var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("h2", { staticClass: "bank-header mb-3" }, [
        _vm._v(" Bank Statement: "),
        _vm.isLoading
          ? _c(
              "span",
              [
                _c("b-spinner", {
                  staticClass: "ml-2",
                  attrs: { small: "", label: "Loading..." },
                }),
              ],
              1
            )
          : _c("span", { staticClass: "bank-name" }, [
              _vm._v(" " + _vm._s(_vm.bankStatementName) + " "),
            ]),
      ]),
      _c("b-table", {
        attrs: {
          items: _vm.transactions,
          fields: _vm.fields,
          bordered: "",
          responsive: "sm",
          "per-page": _vm.perPage,
          "current-page": _vm.currentPage,
        },
        scopedSlots: _vm._u([
          {
            key: "cell(reconciled)",
            fn: function (data) {
              return [
                data.item.reconciled
                  ? _c("span", { staticClass: "badge badge-success" }, [
                      _vm._v("Reconciled"),
                    ])
                  : _c("b-form-checkbox", {
                      attrs: { checked: data.item.reconciled, switch: "" },
                      on: {
                        change: function ($event) {
                          return _vm.toggleRecognized(data.item.transactionId)
                        },
                      },
                    }),
              ]
            },
          },
          {
            key: "cell(date)",
            fn: function (data) {
              return [
                _vm._v(" " + _vm._s(_vm.formatDate(data.item.date)) + " "),
              ]
            },
          },
        ]),
      }),
      _c(
        "div",
        {
          staticClass: "d-flex justify-content-between align-items-center mt-3",
        },
        [
          _c(
            "div",
            { staticClass: "flex-grow-1 d-flex justify-content-center" },
            [
              _c("b-pagination", {
                attrs: {
                  "total-rows": _vm.transactions.length,
                  "per-page": _vm.perPage,
                },
                model: {
                  value: _vm.currentPage,
                  callback: function ($$v) {
                    _vm.currentPage = $$v
                  },
                  expression: "currentPage",
                },
              }),
            ],
            1
          ),
          _c(
            "b-form-group",
            { staticClass: "mb-0 ml-3", attrs: { label: "Rows per page:" } },
            [
              _c("b-form-select", {
                attrs: { options: _vm.perPageOptions },
                model: {
                  value: _vm.perPage,
                  callback: function ($$v) {
                    _vm.perPage = $$v
                  },
                  expression: "perPage",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }